import { useEffect } from 'react';

const useExternalLinkRedirect = (url: string) => {
  useEffect(() => {
    window.location.replace(url);
  }, [url]);
};

export default useExternalLinkRedirect;
